import { render, staticRenderFns } from "./KycOptionsItem.vue?vue&type=template&id=790425d5&scoped=true&"
import script from "./KycOptionsItem.vue?vue&type=script&lang=js&"
export * from "./KycOptionsItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=790425d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790425d5",
  null
  
)

export default component.exports